import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import HomePage from './HomePage';
import { Routes, Route } from 'react-router-dom';
import UserData from '../UserData';
import AgeChart from '../AgeChart';
import ChildProgressAdmission from '../childProgressAdmission/ChildProgressAdmission';
import MedicalForm from '../modals/MedicalForm';
import CodeOfConduct from '../modals/CodeOfConduct';
import DPSubject from '../modals/DPSubject';
import LanguageSurveyForm from '../modals/LanguageSurveyForm';
import MYP4SubjectSelectionForm from '../modals/MYP4SubjectSelectionForm';
import MYP5SubjectSelectionForm from '../modals/MYP5SubjectSelectionForm';
import EssayShortResponseForm from '../modals/EssayShortResponseForm';

const Dashboard = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar />
      <Sidebar />
      <Box
        component="main"
        sx={{ flexGrow: 0.5, p: 0.2, bgcolor: 'background.default', ml: { sm: '5px' }, mt: '5px' }}
      >
        <Toolbar />
        <Routes>
          <Route path="/home" element={<HomePage />} />
          <Route path="/user" element={<UserData />} />
          <Route path="/ageChart" element={<AgeChart />} />
          <Route path="/child-progress-admission/:childId" element={<ChildProgressAdmission />} />
          <Route path="/medical-form" element={<MedicalForm />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/dp-subject" element={<DPSubject />} />
          <Route path="/language-survey-form" element={<LanguageSurveyForm />} />
          <Route path="/myp4-subject-Selection-form" element={<MYP4SubjectSelectionForm />} />
          <Route path="/myp5-subject-Selection-form" element={<MYP5SubjectSelectionForm />} />
          <Route path="/essay-and-short-response-form" element={<EssayShortResponseForm />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default Dashboard;
